import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { CustomerListApi } from "./api";
import ManageColumnDialog from "./ManageColumnDialog";
import { Button } from "@progress/kendo-react-buttons";
import CadsListGrid from "./CadsListGrid";

interface CadsListWidgetProps {
  id: string;
  header: string;
}
const defaultColumns: any = [
    { title: "Device Name", field: "deviceName" },
    { title: "Device Size", field: "deviceSize" },
    { title: "Version Number", field: "versionNumber" },
    { title: "Device Serial", field: "serialNumber" },
    { title: "Main Machine Serial", field: "mainMachineSerial" },
    { title: "Project Number", field: "projectNumber" },
    { title: "Customer ID", field: "customerID" },
    { title: "Customer Name", field: "customerName" },
    { title: "Country", field: "country" },
    { title: "Data Collection", field: "dataCollection" },
    { title: "Created", field: "created" }
]
const defaultUnUsedColumns: any = [

    { title: "Device ID", field: "deviceId" },
    { title: "CADID", field: "customerAssemblyDeviceID" }
]

const CadsListWidget = (props: CadsListWidgetProps) => {
  const [cadsList, updateCadsList] = useState(null);
  const [cadsListLoading, updateLoadingCadsList] = useState(true);
  const [loadingHeader, updateLoadingHeader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [visible, updateVisible] = useState(false);
  const [manageVisible, updateManageVisible] = useState(false);
  const [usedColumns, updateUsedColumns] = useState(defaultColumns);
  const [unUsedColumns, updateUnUsedColumns] = useState(defaultUnUsedColumns);

  const toggleAddColumnDialog = () => {
    visible ? updateVisible(false) : updateVisible(true);
  };
    const toggleManageColumnDialog = () => {
        manageVisible ? updateManageVisible(false) : updateManageVisible(true);
    };
  useEffect(() => {
    getCadsList();
  }, []);

  const addColumn = (hID: any, header: string) => {
    fetchValues(hID, header);
   // updateVisible(false);
  };
    const columnsHandler = (usedColumns: any,unUsedColumns:any) => {
        updateUsedColumns(usedColumns);
        updateUnUsedColumns(unUsedColumns);
        updateManageVisible(false);
    };
  const fetchValues = (hID: any, header: string) => {
    updateLoadingHeader(true);
    CustomerListApi.getHeaderValues({ headerId: hID })
      .then((response: any) => {
        addColumnToData(response, header);
        updateLoadingHeader(false);
        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingHeader(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const addColumnToData = (columnData: any, columnName: string) => {
    const newCadsList = [...cadsList];

    for (let i = 0; i < newCadsList.length; i++) {
      for (let k = 0; k < columnData.length; k++) {
        if (columnData[k].cadid != null && columnData[k].cadid !== 0) {
          if (
            Number(newCadsList[i].customerAssemblyDeviceID) ===
            columnData[k].cadid
          ) {
            newCadsList[i][columnName] = columnData[k].infoValue;
            break;
          } else if (
            newCadsList[i].mainMachineSerial === columnData[k].machineSerial
          ) {
            newCadsList[i][columnName] = columnData[k].infoValue;
            break;
          }
        }
      }
    }
    updateCadsList(newCadsList);
      updateUsedColumns([...usedColumns, { field: columnName, title: columnName }]);
  };

  const getCadsList = () => {
    CustomerListApi.getCadsList()
      .then((response: any) => {
        updateCadsList(response);
        updateLoadingCadsList(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingCadsList(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (cadsListLoading) {
    return <Spinner text="Customer Assembly Devices" />;
  }
  if (loadingHeader) {
    return <Spinner text="Adding new column" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return (
    <>
  
          <Button
              className=" pp-filter-button"
              style={{ marginBottom: "50px", display: "inline-block" }}
              onClick={toggleManageColumnDialog}
          >
              Manage Columns
          </Button>
      <br />
      <CadsListGrid data={cadsList} currentColumns={usedColumns} />
     
          <ManageColumnDialog
              visible={manageVisible}
              toggleVisible={toggleManageColumnDialog}
              columnsHandler={columnsHandler}
              usedColumns={usedColumns}
              unUsedColumns={unUsedColumns}
              addColumn={addColumn}
              loadingHeade={loadingHeader }
          />
    </>
  );
};

export default CadsListWidget;
